






import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { TABLE_DATA } from '@/main/store/listEditTypes';

import { PRACOVNI_POZICE, POLOZKY } from '../constants';
import { store } from '../store/edit';

export default Vue.extend({
	name: 'OZakazkaOtherInfoTable',
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			PRACOVNI_POZICE,
			POLOZKY,
			dependencies: {
				PRACOVNI_POZICE,
				POLOZKY,
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		async refreshTable(name: string) {
			await this.$store.dispatch(`${this.storeUri}/${name}_${TABLE_DATA}`, { filter: (this as any)[`${name}Filter`] });
		},
	},
});
